import React, { useCallback, useEffect, useRef } from "react";
import { IMessage } from "../../domain/message.interface";
import { toZonedTime } from "date-fns-tz";
import { format } from "date-fns";
import { AssistantMessageComponent } from "../assistant-message/assistant-message.component";
import { UserMessageComponent } from "../user-message/user-message.component";
import { Container } from "@mui/system";

import "./body-chat.component.css";

interface IBodyChatComponentProps {
  messages: IMessage[];
  selectButtons: (buttons: string[]) => void;
  setEnabledInput: (enabled: boolean) => void;
}

export const BodyChatComponent: React.FC<IBodyChatComponentProps> = (
  { messages, selectButtons, setEnabledInput },
) => {
  const chatContentRef = useRef<HTMLDivElement>({} as HTMLDivElement);
  const chatMessagesRef = useRef<HTMLDivElement>({} as HTMLDivElement);

  const renderAssistantMessage = useCallback((message: IMessage) => {
    const timeZone = "America/Sao_Paulo";
    const date = new Date(message.timestamp ?? Date.now());
    const saoPauloDate = toZonedTime(date, timeZone);

    const formattedTime = format(saoPauloDate, "HH:mm");

    return (
      <div className="flex items-start self-center">
        <AssistantMessageComponent
          message={message.content}
          buttons={message.buttons}
          time={formattedTime}
          selectButtons={selectButtons}
          setEnabledInput={setEnabledInput}
        />
      </div>
    );
  }, []);

  const renderUserMessage = useCallback((message: IMessage) => {
    const timeZone = "America/Sao_Paulo";
    const date = new Date(message.timestamp ?? Date.now());
    const saoPauloDate = toZonedTime(date, timeZone);

    const formattedTime = format(saoPauloDate, "HH:mm");

    return (
      <div className="flex items-center justify-end w-full">
        <UserMessageComponent message={message.content} time={formattedTime} />
      </div>
    );
  }, []);

  const scrollToMessagesRef = useCallback(() => {
    const index = messages.length - 1;
    const element = chatMessagesRef.current.children[index];
    if (element?.scrollIntoView) element?.scrollIntoView();
  }, [messages]);

  useEffect(() => {
    scrollToMessagesRef();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages]);

  return (
    <>
      <div
        className="flex justify-between items-start bg-[#000050] body-messages"
        ref={chatContentRef}
      >
        <Container
          className="bg-[#000050] overflow-y-auto mb-4"
          ref={chatMessagesRef}
        >
          {messages.map((message, index) => {
            return (
              <div
                key={`message-${index}`}
                className="flex items-start self-center mt-4 mb-12"
              >
                {message.userMessage
                  ? renderUserMessage(message)
                  : renderAssistantMessage(message)}
              </div>
            );
          })}
        </Container>
      </div>
    </>
  );
};
